import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ImportActions from './import_actions';

export class ImportSummary extends React.Component {
  static propTypes = {
    files: PropTypes.object.isRequired,
    importSummary: PropTypes.object.isRequired,
    selectedFileId: PropTypes.number.isRequired
  }

  renderPanel(title, count, className) {
    return (
      <div className={`panel panel-default ${className}`}>
        <div className="p-5">
          <div className="semibold summary-count">{count}</div>
          <div className="h4 semibold mt-0">{title}</div>
        </div>
      </div>
    );
  }

  renderSummaryPanels() {
    const {
      importSummary: { created, failed, skipped, updated }
    } = this.props;

    return (
      <div className="d-inline-flex summary-panels">
        {this.renderPanel("Created", created, "created-panel")}
        {this.renderPanel("Updated", updated, "updated-panel")}
        {this.renderPanel("Failed", failed, "failed-panel")}
        {this.renderPanel("Skipped", skipped, "skipped-panel")}
      </div>
    );
  }

  renderRevertedPanel() {
    const { files, selectedFileId } = this.props;

    return (
      <div className="d-inline-flex summary-panels">
        {this.renderPanel("Reverted", files[selectedFileId].revertedCount, "reverted-panel")}
      </div>
    );
  }

  render() {
    const { files, selectedFileId } = this.props;

    return (
      <div className="panel panel-default">
        <div className="p-5">
          <div className="d-inline-flex w-100 mb-5">
            <div className="w-100">
              <div className="h3 semibold mt-0">
                Import Summary for "{files[selectedFileId].name}"
              </div>
            </div>
            <div className="pull-right">
              <ImportActions />
            </div>
          </div>
          {files[selectedFileId].reverted
            ? this.renderRevertedPanel()
            : this.renderSummaryPanels()
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  files: state.importObject.files,
  selectedFileId: state.ui.selectedFileId,
  importSummary: state.runRecords.importSummary
});

export default connect(mapStateToProps)(ImportSummary);